import { Component } from '@angular/core';

@Component({
  selector: 'app-error-badrequest',
  templateUrl: './errorbadrequest.component.html',
  styleUrls: ['./errorbadrequest.component.scss']
})
export class ErrorbadrequestComponent {

}